const template2 = `# Template 2: Greet User
username = node_input.get('username', 'World')
output = {'message': f'Hello, {username}!'}
`

export default template2;
